import { EditComponent } from '../../app-lite/table/cell-components/actions/edit.component';

export function InvoiceAttachedOrdersCtrl (
  $scope,
  $state,
  $translate,
  workshopAPI
) {
  $scope.showAttachedOrders = false;

  $scope.tableSettings = {
    columns: [
      {
        classes: 'all-caps',
        field  : 'order_number',
        header : {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_NUMBER')
        }
      },
      {
        field : 'order_date',
        header: {
          text: $translate.instant('PURCHASE_ORDER_SPACE.ORDER_DATE')
        },
        pipe: 'globalDate'
      },
      {
        field : 'status',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.STATUS')
        },
        pipe: 'purchaseOrderStatus'
      },
      {
        field : 'item_code',
        header: {
          text: $translate.instant('PRODUCT_SPACE.ITEM_CODE')
        }
      },
      {
        field : 'vendor_name',
        header: {
          text: $translate.instant('VENDOR_SPACE.SUPPLIER')
        }
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: event => $scope.viewOrder(event)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ORDERS_FOUND')
    },
    pagination: {
      enabled: false,
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: true
    },
  };

  $scope.onRowDoubleClick = function (event) {
    $scope.viewOrder(event.row);
  };

  $scope.viewOrder = function (order) {
    $state.go('app.purchase-order', {
      vendor_id: order.vendor_id,
      id       : order.purchase_order_id
    });
  };

  $scope.getOrders = function () {
    return workshopAPI.get('/purchase_order_items/attached_orders', $scope.invoice.id).then(function (orders) {
      $scope.orders = orders;
      return orders;
    });
  };

  $scope.getOrders();
};